module.exports = __webpack_public_path__ + "img/onePieceSkirt.6b8239e3.png";